"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Search.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Search = function Search(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 147.48 153.91"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Search Icon"), _react2.default.createElement("path", {
    d: "M146.39 139.12L114.88 104a64.2 64.2 0 1 0-14.63 13.65l31.28 34.9a4.26 4.26 0 0 0 6 .31l8.54-7.7a4.26 4.26 0 0 0 .32-6.04zM20 64.31a44.31 44.31 0 1 1 44.31 44.31A44.36 44.36 0 0 1 20 64.31z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Search;